export class Validation{
    static InstrumentationKey(instrumentationKey: string){
        if(instrumentationKey && instrumentationKey.length > 0){
            return true;
        }
        else{
            return false;
        }
    }
}